import { useCallback } from "react";
import { Category, ContextPage, EventType } from "../constants";
import { useTrackingEvent } from "./useTrackingEvent";

export const useFavoriteTracking = ({ page = ContextPage.TRIPS_LIST } = {}) => {
  const { runtime, trackEvent } = useTrackingEvent();

  const trackAddToFavorites = useCallback(
    async ({ establishmentId, publicationId }) => {
      if (!establishmentId || !publicationId) return;

      await trackEvent({
        schemaVersion: runtime.schemaVersion,
        eventTime: new Date().toISOString(),
        category: Category.CONVERSION_EVENT,
        eventType: EventType.ADD_TO_FAVORITES,
        establishmentId,
        publicationId,
        visitorCountry: runtime.visitorCountry?.countryCode || undefined,
        context: { source: runtime.trackingSource, page },
      });
    },
    [page, runtime, trackEvent]
  );

  return { trackAddToFavorites };
};
